import script from "./Shuizhong.vue?vue&type=script&setup=true&lang=ts"
export * from "./Shuizhong.vue?vue&type=script&setup=true&lang=ts"

import "./Shuizhong.vue?vue&type=style&index=0&id=6d9f050d&lang=less&scoped=true"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d9f050d"]])

export default __exports__